import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { AbntPipe } from '../../../../../shared/pipes/abnt.pipe';
import { AlertService, AlertType } from '../../../../../shared/services/alert.service';
import { OrdemProducaoOrquestradorService } from '../../../../../shared/services/apis/orquestrador-suprimentos/ordem-producao-orquestrador.service';
import { ResumoEstoqueEntradaOrdemProducaoStruct } from '../../../../../shared/services/structs/suprimentos/resumo-estoque-entrada-ordem-producao.struct';
import { ResumoEstoqueInsumoOrdemProducaoStruct } from '../../../../../shared/services/structs/suprimentos/resumo-estoque-insumo-ordem-producao.struct';

/** Aberto pelo detalhe e pela linha da lista: só o que o diálogo exibe e usa para buscar o resumo. */
export interface ExcluirEstoqueOrdemProducaoDialogData {
  idOrdemProducao: number;
  numero: number;
  nomeProduto: string;
}

/** Diálogo simétrico ao de lançar (seção 5.2): mostra de onde vai devolver o insumo e de onde vai
 * sair o produto fabricado, lido das movimentações já gravadas, e pede a justificativa da exclusão.
 * Fecha com a justificativa; quem exclui o estoque é a tela que abriu. */
@Component({
  selector: 'app-excluir-estoque-ordem-producao-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatProgressSpinnerModule,
    AbntPipe,
  ],
  templateUrl: './excluir-estoque-ordem-producao-dialog.component.html',
  styleUrl: './excluir-estoque-ordem-producao-dialog.component.css',
})
export class ExcluirEstoqueOrdemProducaoDialogComponent implements OnInit {
  public isCarregando = true;
  public readonly justificativa = new FormControl('', {
    nonNullable: true,
    validators: [Validators.required, Validators.minLength(10), Validators.maxLength(500)],
  });
  public entrada: ResumoEstoqueEntradaOrdemProducaoStruct | null = null;
  public insumos: ResumoEstoqueInsumoOrdemProducaoStruct[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ExcluirEstoqueOrdemProducaoDialogData,
    public dialogRef: MatDialogRef<ExcluirEstoqueOrdemProducaoDialogComponent>,
    private alertService: AlertService,
    private ordemProducaoOrquestradorService: OrdemProducaoOrquestradorService,
  ) {}

  public ngOnInit(): void {
    this.ordemProducaoOrquestradorService.getResumoEstoque(this.data.idOrdemProducao).subscribe({
      next: (res) => {
        this.isCarregando = false;
        if (res.isError) {
          this.alertService.show('Erro', res.errorDescription, AlertType.error);
          return;
        }
        this.entrada = res.entrada;
        this.insumos = res.insumos ?? [];
      },
      error: (err) => {
        this.isCarregando = false;
        this.alertService.show('Erro inesperado', err.message ?? err, AlertType.error);
      },
    });
  }

  public cancelar(): void {
    this.dialogRef.close();
  }

  public confirmar(): void {
    this.justificativa.markAsTouched();
    if (this.justificativa.invalid) return;
    this.dialogRef.close(this.justificativa.value.trim());
  }
}
